module.exports = __webpack_public_path__ + "static/media/guitar.3a536c71.wav";